import React, {useState, useMemo, useEffect} from "react";
import { Button, SHAPE, KIND, SIZE as BTN_SIZE } from "baseui/button";
import { StatefulPopover, PLACEMENT } from "baseui/popover";
import { FaQuestionCircle, FaCheckCircle, FaRegCircle,FaArrowUp, FaArrowDown } from "react-icons/fa";
const Stats = ({ topic, data, readHistory }) => {

  const [showScrollButton, setShowScrollButton] = useState(false);

  // Pre-compute your counts
  const { totalQuestions, readQuestions, unreadQuestions } = useMemo(() => {
    const total = data.length;
    const read = data.reduce((sum, q) => sum + (readHistory[q.id] === true ? 1 : 0), 0);
    return { totalQuestions: total, readQuestions: read, unreadQuestions: total - read };
  }, [data, readHistory]);

  const currTopic = topic || "All";

  // Build the popover content once
  const content = (
      <div style={popoverStyles.panel}>
        <h5 style={popoverStyles.heading}>Statistics ({currTopic})</h5>
        <div style={popoverStyles.statItem}>
          <FaQuestionCircle style={popoverStyles.icon} />
          <span style={popoverStyles.text}>Total: {totalQuestions}</span>
        </div>
        <div style={popoverStyles.statItem}>
          <FaCheckCircle style={popoverStyles.icon} />
          <span style={popoverStyles.text}>Read: {readQuestions}</span>
        </div>
        <div style={popoverStyles.statItem}>
          <FaRegCircle style={{ ...popoverStyles.icon, color: "#28a745" }} />
          <span style={popoverStyles.text}>Unread: {unreadQuestions}</span>
        </div>
      </div>
  );


  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleScrollDown = () => {
    window.scrollBy({ top: 200, behavior: "smooth" }); // Scroll down by 200px
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  return (
      <>
      <StatefulPopover
          content={() => content}
          placement={PLACEMENT.bottomRight}
          triggerType="click"
          overrides={{
            Body: {
              style: {
                // pop-in animation
                animationName: {
                  from: { opacity: 0, transform: "scale(0.8)" },
                  to:   { opacity: 1, transform: "scale(1)" }
                },
                animationDuration: "200ms",
                animationTimingFunction: "ease-out",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
              }
            }
          }}
      >
        <Button
            shape={SHAPE.circle}
            kind={KIND.secondary}
            size={BTN_SIZE.compact}
            overrides={{
              BaseButton: {
                style: {
                  position: "fixed",
                  bottom: "24px",
                  right: "24px",
                  width: "40px",
                  height: "40px",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }
              }
            }}
        >
          <FaQuestionCircle size={18} />
        </Button>
      </StatefulPopover>
        {showScrollButton && (
            <div style={popoverStyles.scrollButtonContainer}>
              <div style={popoverStyles.scrollToTopButton} onClick={handleScrollToTop}>
                <FaArrowUp />
              </div>
              <div style={popoverStyles.scrollToBottomButton} onClick={handleScrollDown}>
                <FaArrowDown />
              </div>
            </div>
        )}
</>
  );
};

const popoverStyles = {
  scrollButtonContainer: {
    position: "fixed",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)", // Centers the container horizontally
    display: "flex", // Aligns the buttons horizontally
    gap: "10px", // Adds some space between the buttons
  },
  scrollToTopButton: {
    width: "30px", // Smaller width
    height: "30px", // Smaller height
    backgroundColor: "#6c757d", // Lighter background color
    color: "#fff",
    border: "2px solid #fff",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px", // Adjust font size for icon
    transition: "opacity 0.3s, transform 0.3s",
  },
  scrollToBottomButton: {
    width: "30px", // Smaller width
    height: "30px", // Smaller height
    backgroundColor: "#6c757d", // Lighter background color
    color: "#fff",
    border: "2px solid #fff",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px", // Adjust font size for icon
    transition: "opacity 0.3s, transform 0.3s",
  },
  panel: {
    backgroundColor: "#fff",
    padding: "12px",
    width: "160px",
    display: "flex",
    flexDirection: "column"
  },
  heading: {
    margin: 0,
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "600"
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "6px"
  },
  icon: {
    marginRight: "6px",
    fontSize: "16px",
    color: "#007BFF"
  },
  text: {
    fontSize: "12px",
    color: "#333",
    margin: 0
  }
};

export default Stats;
